export default "__VITE_ASSET__8b07c4e3__"